import * as Sentry from "@sentry/react";

import { getSoftwareVersionCommitHash } from "@/lib/string-utils";

const environment = import.meta.env.MODE;

Sentry.init({
	dsn: "https://cdf75412a9e951eb7faf308b75c80e2d@o4510945750614016.ingest.de.sentry.io/4510947324985424",
	release: getSoftwareVersionCommitHash(),
	sendDefaultPii: true,
	enabled: environment === "prod" || environment === "production",
});
